import {
  ExcludedReason,
  type ExcludedReasonValue,
  type IOutcomeExcludedMarket,
} from "~/types/event";

const withheld: ExcludedReasonValue = ExcludedReason.WITHHELD;

export const getWithheldMarketCount = (
  excluded: readonly IOutcomeExcludedMarket[] = []
): number => excluded.filter(({ reason }) => reason === withheld).length;
